var _path, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.137,39.013h0c-1.26,0-2.262-1.059-2.192-2.317l.693-12.472h-2.746l1.203-17.844c.093-1.376,1.236-2.445,2.616-2.445h0c1.448,0,2.622,1.174,2.622,2.622v30.261c0,1.212-.983,2.195-2.195,2.195Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.668,2.987v10.352c0,1.369.807,2.609,2.059,3.162l.092.041c.902.399,1.452,1.326,1.369,2.309l-1.435,16.99c-.144,1.707,1.203,3.172,2.916,3.172h0c1.699,0,3.041-1.443,2.919-3.138l-1.237-17.092c-.069-.95.452-1.844,1.311-2.254h0c1.204-.574,1.97-1.788,1.97-3.121V2.987"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.003,
    y1: 2.987,
    x2: 14.003,
    y2: 11.418
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.297,
    y1: 2.987,
    x2: 17.297,
    y2: 11.418
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorRestaurant);
export default __webpack_public_path__ + "static/media/indoor-restaurant.ac364d45f2abfc9d4c3839bc8138080d.svg";
export { ForwardRef as ReactComponent };